import React, { createContext } from 'react';
// Create the context with a default empty object matching the error '{}'
export var IdeMessengerContext = /*#__PURE__*/ createContext({});
// Optional: Provider component (can be implemented later)
export var IdeMessengerProvider = function(param) {
    var children = param.children, messenger = param.messenger;
    return /*#__PURE__*/ React.createElement(IdeMessengerContext.Provider, {
        value: messenger
    }, children);
};
// Export the context itself for use with useContext
export default IdeMessengerContext;
